var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD28Working",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrows_SVG",
    transform: "translate(-19.000000, -15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(19.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 0.000000)",
    fill: "#34A853",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    transform: "translate(6.000000, 3.500000) rotate(-180.000000) translate(-6.000000, -3.500000) ",
    points: "12 1.40880503 10.4724409 0 6 4.24414416 1.52755906 0 0 1.40880503 6 7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    transform: "translate(6.000000, 10.500000) rotate(-180.000000) translate(-6.000000, -10.500000) ",
    points: "12 8.40880503 10.4724409 7 6 11.2441442 1.52755906 7 0 8.40880503 6 14"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleUp);
export default __webpack_public_path__ + "static/media/double-up.31cc7897aef2be29ee3cbeb7a0d230d7.svg";
export { ForwardRef as ReactComponent };